'use strict';

require('./bootstrap');
require('./services/DynamicFormService');
require('./controllers/DynamicFormCtrl');